import * as AdminConstants from '../../action/admin/AdminConstants';

const initialState = {
  allUsersData: [],
  allUsersDataIsFetching: false,
  allUsersDataErrorMessage: '',
  userDataById: [],
  userDataByIdIsFetching: false,
  userDataByIdErrorMessage: '',
  savedUserData: {},
  savedUserDataIsFetching: false,
  savedUserDataErrorMessage: '',
  updatedUserData: {},
  updatedUserDataIsFetching: false,
  updatedUserDataErrorMessage: '',
  updatedUserPasswordData: {},
  updatedUserPasswordDataIsFetching: false,
  updatedUserPasswordDataErrorMessage: '',
  userQueuesData: [],
  userQueuesDataIsFetching: false,
  userQueuesDataErrorMessage: '',
  replacedUserQueuesData: [],
  replacedUserQueuesDataIsFetching: false,
  replacedUserQueuesDataErrorMessage: '',
  userQueueCount: {},
  userQueueCountIsFetching: false,
  userQueueCountErrorMessage: '',
  userQueueValidData: {},
  userQueueValidDataIsFetching: false,
  userQueueValidDataErrorMessage: '',
  runQueryData: {}
};

export const adminStore = (state = initialState, action) => {
  switch (action.type) {
    //GET LIST OF ALL USER
    case AdminConstants.GET_ALL_USERS_DATA_REQUEST:
      return {
        ...state,
        allUsersDataIsFetching: true,
        allUsersDataErrorMessage: ''
      };
    case AdminConstants.GET_ALL_USERS_DATA_SUCCESS:
      return {
        ...state,
        allUsersDataIsFetching: false,
        allUsersData: action.data
      };
    case AdminConstants.GET_ALL_USERS_DATA_FAILED:
      return {
        ...state,
        allUsersDataIsFetching: false,
        allUsersDataErrorMessage: 'SERVER ERROR'
      };
    case AdminConstants.GET_ALL_USERS_DATA_CLEAR:
      return {
        ...state,
        allUsersDataIsFetching: false,
        allUsersData: [],
        allUsersDataErrorMessage: ''
      };

    case AdminConstants.GET_USER_DATA_BY_ID_REQUEST:
      return {
        ...state,
        userDataByIdIsFetching: true,
        userDataByIdErrorMessage: ''
      };
    case AdminConstants.GET_USER_DATA_BY_ID_SUCCESS:
      return {
        ...state,
        userDataByIdIsFetching: false,
        userDataById: action.data
      };
    case AdminConstants.GET_USER_DATA_BY_ID_FAILED:
      return {
        ...state,
        userDataByIdIsFetching: false,
        userDataByIdErrorMessage: 'SERVER ERROR'
      };
    case AdminConstants.GET_USER_DATA_BY_ID_CLEAR:
      return {
        ...state,
        userDataByIdIsFetching: false,
        userDataById: [],
        userDataByIdErrorMessage: ''
      };
    case AdminConstants.SAVE_USER_DATA_REQUEST:
      return {
        ...state,
        savedUserDataIsFetching: true,
        savedUserDataErrorMessage: ''
      };
    case AdminConstants.SAVE_USER_DATA_SUCCESS:
      return {
        ...state,
        savedUserDataIsFetching: false,
        savedUserData: action.data
      };
    case AdminConstants.SAVE_USER_DATA_FAILED:
      return {
        ...state,
        savedUserDataIsFetching: false,
        savedUserDataErrorMessage: action.error.message
        // savedUserDataErrorMessage: 'SERVER ERROR',
      };
    case AdminConstants.SAVE_USER_DATA_CLEAR:
      return {
        ...state,
        savedUserDataIsFetching: false,
        savedUserData: {},
        savedUserDataErrorMessage: ''
      };

    case AdminConstants.UPDATE_USER_DATA_REQUEST:
      return {
        ...state,
        updatedUserDataIsFetching: true,
        updatedUserDataErrorMessage: ''
      };
    case AdminConstants.UPDATE_USER_DATA_SUCCESS:
      return {
        ...state,
        updatedUserDataIsFetching: false,
        updatedUserData: action.data
      };
    case AdminConstants.UPDATE_USER_DATA_FAILED:
      return {
        ...state,
        updatedUserDataIsFetching: false,
        updatedUserDataErrorMessage: action.error.message
        // updatedUserDataErrorMessage: 'SERVER ERROR',
      };
    case AdminConstants.UPDATE_USER_DATA_CLEAR:
      return {
        ...state,
        updatedUserDataIsFetching: false,
        updatedUserData: {},
        updatedUserDataErrorMessage: ''
      };

    case AdminConstants.RESET_USER_PASSWORD_REQUEST:
      return {
        ...state,
        updatedUserPasswordDataIsFetching: true,
        updatedUserPasswordDataErrorMessage: ''
      };
    case AdminConstants.RESET_USER_PASSWORD_SUCCESS:
      return {
        ...state,
        updatedUserPasswordDataIsFetching: false,
        updatedUserPasswordData: action.data
      };
    case AdminConstants.RESET_USER_PASSWORD_FAILED:
      return {
        ...state,
        updatedUserPasswordDataIsFetching: false,
        updatedUserPasswordDataErrorMessage: action.error.message
        // updatedUserPasswordDataErrorMessage: 'SERVER ERROR',
      };
    case AdminConstants.RESET_USER_PASSWORD_CLEAR:
      return {
        ...state,
        updatedUserPasswordDataIsFetching: false,
        updatedUserPasswordData: {},
        updatedUserPasswordDataErrorMessage: ''
      };

    case AdminConstants.GET_USER_QUEUES_DATA_REQUEST:
      return {
        ...state,
        userQueuesDataIsFetching: true,
        userQueuesDataErrorMessage: ''
      };
    case AdminConstants.GET_USER_QUEUES_DATA_SUCCESS:
      return {
        ...state,
        userQueuesDataIsFetching: false,
        userQueuesData: action.data
      };
    case AdminConstants.GET_USER_QUEUES_DATA_FAILED:
      return {
        ...state,
        userQueuesDataIsFetching: false,
        userQueuesDataErrorMessage: 'SERVER ERROR'
      };
    case AdminConstants.GET_USER_QUEUES_DATA_CLEAR:
      return {
        ...state,
        userQueuesDataIsFetching: false,
        userQueuesData: [],
        userQueuesDataErrorMessage: ''
      };

    case AdminConstants.REPLACE_USER_QUEUES_DATA_REQUEST:
      return {
        ...state,
        replacedUserQueuesDataIsFetching: true,
        replacedUserQueuesDataErrorMessage: ''
      };
    case AdminConstants.REPLACE_USER_QUEUES_DATA_SUCCESS:
      return {
        ...state,
        replacedUserQueuesDataIsFetching: false,
        replacedUserQueuesData: action.data
      };
    case AdminConstants.REPLACE_USER_QUEUES_DATA_FAILED:
      return {
        ...state,
        replacedUserQueuesDataIsFetching: false,
        // replacedUserQueuesDataErrorMessage: 'SERVER ERROR',
        // replacedUserQueuesDataErrorMessage: action.error.message
        replacedUserQueuesDataErrorMessage: action.error.message || action.error
      };
    case AdminConstants.REPLACE_USER_QUEUES_DATA_CLEAR:
      return {
        ...state,
        replacedUserQueuesDataIsFetching: false,
        replacedUserQueuesData: [],
        replacedUserQueuesDataErrorMessage: ''
      };

    case AdminConstants.GET_USER_QUEUES_COUNT_DATA_REQUEST:
      return {
        ...state,
        userQueueCountIsFetching: true,
        userQueueCountErrorMessage: ''
      };
    case AdminConstants.GET_USER_QUEUES_COUNT_DATA_SUCCESS:
      return {
        ...state,
        userQueueCountIsFetching: false,
        userQueueCount: action.data
      };
    case AdminConstants.GET_USER_QUEUES_COUNT_DATA_FAILED:
      return {
        ...state,
        userQueueCountIsFetching: false,
        // userQueueCountErrorMessage: 'SERVER ERROR',
        userQueueCountErrorMessage: action.error.message
      };
    case AdminConstants.GET_USER_QUEUES_COUNT_DATA_CLEAR:
      return {
        ...state,
        userQueueCountIsFetching: false,
        userQueueCount: {},
        userQueueCountErrorMessage: ''
      };

    case AdminConstants.GET_VALIDATE_USER_QUEUES_DATA_REQUEST:
      return {
        ...state,
        userQueueValidDataIsFetching: true,
        userQueueValidDataErrorMessage: ''
      };
    case AdminConstants.GET_VALIDATE_USER_QUEUES_DATA_SUCCESS:
      return {
        ...state,
        userQueueValidDataIsFetching: false,
        userQueueValidData: action.data
      };
    case AdminConstants.GET_VALIDATE_USER_QUEUES_DATA_FAILED:
      return {
        ...state,
        userQueueValidDataIsFetching: false,
        // userQueueValidDataErrorMessage: 'SERVER ERROR',
        userQueueValidDataErrorMessage: action.error.message
      };
    case AdminConstants.GET_VALIDATE_USER_QUEUES_DATA_CLEAR:
      return {
        ...state,
        userQueueValidDataIsFetching: false,
        userQueueValidData: {},
        userQueueValidDataErrorMessage: ''
      };

    case AdminConstants.CHANGE_RUN_QUERY_OBJECT:
      return {
        ...state,
        runQueryData: action.data
      };

    case AdminConstants.CHANGE_RUN_QUERY_OBJECT_CLEAR:
      return {
        ...state,
        runQueryData: {}
      };

    default:
      return state;
  }
};
